import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/forms/pages/")({
    beforeLoad: () => {
        throw redirect({ to: "/design/forms/pages/$screen", params: { screen: "cover" } });
    },
});
